export const LAB_TEST_DEFAULT_VALUE = {
  id: "",
  category: {
    category: "",
    helperText: "",
    error: false,
  },
  testName: {
    testName: "",
    helperText: "",
    error: false,
  },
  description: {
    description: "",
    helperText: "",
    error: false,
  },
  sampleType: {
    sampleType: "",
    helperText: "",
    error: false,
  },
  estimatedTime: {
    estimatedTime: "",
    helperText: "",
    error: false,
  },
  amount: {
    amount: "",
    helperText: "",
    error: false,
  },
  active: true,
};
